var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.62,
    height: 18.62,
    viewBox: "0 0 18.62 18.62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_8_pomoc"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.62,
    height: 18.62
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8_pomoc",
    "data-name": "8 pomoc",
    clipPath: "url(#clip-_8_pomoc)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 0.909,
    cy: 0.909,
    r: 0.909,
    transform: "translate(8.399 12.853)",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M9.308,0a9.308,9.308,0,1,0,9.308,9.308A9.3,9.3,0,0,0,9.308,0Zm0,17.162a7.854,7.854,0,1,1,7.854-7.854A7.849,7.849,0,0,1,9.308,17.162Z",
    fill: "#a8b0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M178.909,128.5A2.912,2.912,0,0,0,176,131.409a.727.727,0,1,0,1.454,0,1.454,1.454,0,1,1,1.454,1.454.727.727,0,0,0-.727.727v1.818a.727.727,0,0,0,1.454,0v-1.183a2.909,2.909,0,0,0-.727-5.726Z",
    transform: "translate(-169.601 -123.828)",
    fill: "#a8b0b6"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.f2053207.svg";
export { ForwardRef as ReactComponent };